import React from 'react';

import { DetailsRowContainer, RequiredMark } from 'components/Entities/AddEntityModal/styles';
import { InputHeader } from 'containers/Audits/components/StartAuditModal/styles';

type FormRowProps = {
  testId: string;
  label: string;
  children: React.ReactNode;
};

const FormRow: React.FunctionComponent<FormRowProps> = ({ testId, label, children }) => (
  <DetailsRowContainer data-testid={testId}>
    <InputHeader>
      {label} <RequiredMark>*</RequiredMark>
    </InputHeader>
    {children}
  </DetailsRowContainer>
);

export default FormRow;
